import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import BillingAPI from '../../../../utils/api/billingAPI';

const entity = new ReduxRestEntity({
  name: 'billing',
  api: BillingAPI(),
});

export default entity;
